import { LineItemModel } from '../models/LineItem.model';

export function hasShippableItems(lineItems: LineItemModel[]): boolean {
  return lineItems.some((lineItem) => lineItem.shippable);
}
